import { App } from "vue";
import copy from "./modules/copy";
import debounce from "./modules/debounce";
import draggable from "./modules/draggable";
import inputDecimal from "./modules/inputDecimal";
import longpress from "./modules/longpress";
import overflowToolTip from "./modules/overflowToolTip";
import throttle from "./modules/throttle";
import waterMarker from "./modules/waterMarker";

const directivesList: any = {
	// Custom directives
	copy,
	waterMarker,
	draggable,
	debounce,
	throttle,
	longpress,
	inputDecimal,
	overflowToolTip
};

const directives = {
	install: function (app: App<Element>) {
		Object.keys(directivesList).forEach(key => {
			// 注册所有自定义指令
			app.directive(key, directivesList[key]);
		});
	}
};

export default directives;
